import React, { useRef, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';

const ChatInput = ({ inputMessage, setInputMessage, handleSubmit, isLoading }) => {
  const { t } = useLanguage();
  const inputRef = useRef(null);

  // Focus input on mount
  useEffect(() => {
    inputRef.current?.focus();
  }, []);  

  // Focus after message is sent or loading state changes
  useEffect(() => {
    if (!isLoading) {
      inputRef.current?.focus();
    }
  }, [isLoading, inputMessage]);

  return (
    <form onSubmit={handleSubmit} className="flex items-center p-4 border-t border-gray-700">
      <input
        ref={inputRef}
        type="text"
        value={inputMessage}
        onChange={(e) => setInputMessage(e.target.value)}
        placeholder={t('yourMessage')}
        className="flex-1 p-2 mr-2 bg-gray-800 text-white rounded border border-gray-600 focus:border-blue-500 focus:outline-none"
        disabled={isLoading}
      />
      <button
        type="submit"
        className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 disabled:opacity-50"
        disabled={isLoading || !inputMessage.trim()}
      >
        {t('send')}
      </button>
    </form>
  );
};

export default ChatInput;
